import { h } from 'preact';

import Skeleton from '@mui/material/Skeleton';

export default function LazyBarVariation(props) {
  return <Skeleton width={'100%'} height={250} variant="rounded" />;
}
